<h1 mat-dialog-title>Widget configuration</h1>
<div mat-dialog-content>
    <pre><p>{{data | json}}</p></pre>
</div>
<div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="data.widgetId" cdkFocusInitial>Close</button>
</div>
